import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import Start from './Start.tsx';
import Order from './Order.tsx';
import { fetchPromise } from './apiHelper.ts';
import Error from './Error.tsx';
import { OrderData, WithdrawalsData } from './types.ts';

export default function Withdrawals(props: WithdrawalsData) {
  const [showStartForm, setShowStartForm] = useState(false);
  const [currentOrder, setCurrentOrder] = useState<OrderData | null>(null);
  const [showHomeDeliveryDesc, setShowHomeDeliveryDesc] = useState(false);
  const [showError, setShowError] = useState(false);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const orderId = urlParams.get('orderId');
    if (!orderId) {
      setShowStartForm(true);
      return;
    }

    const url = '/api/sitecore/withdrawals/GetOrder';
    const options: RequestInit = {
      method: 'POST',
      body: JSON.stringify({
        OrderId: orderId,
      }),
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    };
    try {
      fetchPromise<OrderData>(url, options)
        .then((response) => {
          if (response.Success) {
            setShowHomeDeliveryDesc(response.ShipMethodIsHomeDelivery);
            setCurrentOrder(response);
            scrollToTop();
          } else {
            setShowStartForm(true);
          }
        })
        .catch(() => {
          setShowError(true);
        });
    } catch (err) {
      console.log('error in post request');
      console.log(err);
    }
  }, []);

  return (
    <div className="thule-container withdrawals">
      {showError ? (
        <Error />
      ) : (
        <>
          {currentOrder ? (
            <Order
              {...props}
              currentOrder={currentOrder}
              scrollToTop={scrollToTop}
              showHomeDeliveryDesc={showHomeDeliveryDesc}
            />
          ) : (
            <Start
              {...props}
              showStartForm={showStartForm}
              setShowStartForm={setShowStartForm}
              setCurrentOrder={setCurrentOrder}
              scrollToTop={scrollToTop}
              setShowHomeDeliveryDesc={setShowHomeDeliveryDesc}
            />
          )}
        </>
      )}
    </div>
  );
}

const rootElement = document.getElementById('REACT_withdrawals');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <Sentry.ErrorBoundary>
      <Withdrawals {...window._THULEDATA._Withdrawals} />
    </Sentry.ErrorBoundary>
  );
}
